import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__generation_consume_content } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_consume_content';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_consume_content = createAsyncThunkSafe<any, DTO_REQUEST__generation_consume_content>(
  ENUM__network_event_client_to_server.GENERATION_CONSUME_CONTENT,
  async (request, thunk_api): Promise<void> => {
    return await send_to_server(ENUM__network_event_client_to_server.GENERATION_CONSUME_CONTENT, request);
  },
);

export function INIT_REMOTE__generation_consume_content(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_consume_content.pending, (state, action) => {})
    .addCase(REMOTE__generation_consume_content.rejected, (state, action) => {})
    .addCase(REMOTE__generation_consume_content.fulfilled, (state, action: PayloadAction) => {});
}
